<template>
  <div class="flex flex-col justify-between">
    <el-form ref="formRef" label-position="top" :model="form" size="large">
      <div class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <el-form-item label="Agent名称" prop="name" :rules="[{ required: true, message: '请填写Agent名称', trigger: 'blur' }]">
              <el-input v-model="form.name" placeholder="请填写Agent名称"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="性别" prop="gender" :rules="[{ required: true, message: '请选择性别', trigger: 'change' }]">
              <el-select v-model="form.gender" placeholder="请选择性别" class="w-full">
                <el-option value="male" label="男性" />
                <el-option value="female" label="女性" />
                <el-option value="neutral" label="中性" />
              </el-select>
            </el-form-item>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <el-form-item label="语音" prop="voiceId" :rules="[{ required: true, message: '请选择语音', trigger: 'change' }]">
              <el-select v-model="form.voiceId" placeholder="请选择语音" class="w-full">
                <el-option v-for="voice in options?.voices || []" :key="voice.id" :value="voice.id" :label="voice.name" />
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="提供商" prop="provider" :rules="[{ required: true, message: '请选择提供商', trigger: 'change' }]">
              <el-select v-model="form.provider" placeholder="请选择提供商" class="w-full">
                <el-option v-for="provider in options?.providers || []" :key="provider" :value="provider" :label="provider" />
              </el-select>
            </el-form-item>
          </div>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <el-form-item label="模型" prop="model" :rules="[{ required: true, message: '请选择模型', trigger: 'change' }]">
              <el-select v-model="form.model" placeholder="请选择模型" class="w-full">
                <el-option v-for="model in (options?.models || []).filter((m) => m.provider === form.provider)" 
                  :key="model.id" :value="model.id" :label="model.name" />
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="类型" prop="type" :rules="[{ required: true, message: '请选择类型', trigger: 'change' }]">
              <el-select v-model="form.type" placeholder="请选择类型" class="w-full">
                <el-option v-for="type in options?.types || []" :key="type.value" :value="type.value" :label="type.label" />
              </el-select>
            </el-form-item>
          </div>
        </div>
        
        <div>
          <el-form-item label="提示词" prop="prompt" :rules="[{ required: true, message: '请填写提示词', trigger: 'blur' }]">
            <el-input
              v-model="form.prompt"
              placeholder="请填写Agent的提示词"
              type="textarea"
              :rows="4"
              resize="vertical"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue'
const Message = {
  error: (message) => ElMessage.error(message)
}

const props = defineProps({
  target: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({
      providers: [],
      models: [],
      voices: [],
      types: [],
    }),
  },
})

const emit = defineEmits(['submitUpdate'])
const formRef = ref(null)
const loading = ref(false)
const form = ref(props.target ? { ...props.target } : {
  id: '',
  name: '',
  gender: '',
  voiceId: '',
  provider: '',
  model: '',
  type: '',
  prompt: '',
})

const submit = async () => {
  try {
    loading.value = true
    await formRef.value?.validate()
    
    await router.post(routes.upsert_admin_aigc_agents(), form.value, {
      onSuccess: () => { emit('submitUpdate', true) },
      onFinish: () => {
        loading.value = false
      }
    })
  } catch (error) {
    ElMessage.error(error?.message || '表单验证失败')
    loading.value = false
    emit('submitUpdate', false)
  }
}

// 监听 target 变化，更新表单数据
watchEffect(() => {
  if (props.target) form.value = { ...props.target }
})

defineExpose({ submit })
</script>
